import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { AvatarWithUpload } from 'components/modules/user/AvatarWithUpload';
import ChangePasswordModal from 'components/modules/user/change-password-modal';
import Sidebar from 'components/modules/user/warehouse/Sidebar';
import SessionStore from 'stores/SessionStore';
import Container from 'components/v2/container';
import CargomaticCard from 'components/v2/card';
import { titleize } from 'underscore.string';
import CargomaticInput from 'components/v2/input';
import PhoneField from 'components/v2/forms/PhoneField';
import CustomersActionCreators from 'actions/CustomersActionCreators';
import CustomersAPIUtils, { getCustomer } from 'utils/CustomersAPIUtils';
import validator from 'email-validator';
import { isEmpty, isEqual } from 'lodash';
const pageTestKey = 'warehouse-portal-profile';
const Profile = () => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
    const { t } = useTranslation();
    const [warehouseUser, setWarehouseUser] = useState({});
    const [initWarehouseUser, setInitiWarehouseUser] = useState({});
    const [showChangePasswordModal, setShowChangePasswordModal] = useState(false);
    const [displayName, setDisplayName] = useState('');
    const fetchUser = async () => {
        const user = SessionStore.getUser();
        const result = await getCustomer(user._id);
        if (result === null || result === void 0 ? void 0 : result.entity) {
            setInitiWarehouseUser(result.entity);
            setWarehouseUser(result.entity);
            const { first_name, last_name } = result.entity;
            setDisplayName(`${first_name} ${last_name}`);
        }
    };
    useEffect(() => {
        fetchUser();
    }, []);
    const saveDisabled = isEmpty((_a = warehouseUser === null || warehouseUser === void 0 ? void 0 : warehouseUser.first_name) === null || _a === void 0 ? void 0 : _a.trim()) ||
        isEmpty((_b = warehouseUser === null || warehouseUser === void 0 ? void 0 : warehouseUser.last_name) === null || _b === void 0 ? void 0 : _b.trim()) ||
        isEmpty((_c = warehouseUser === null || warehouseUser === void 0 ? void 0 : warehouseUser.phone) === null || _c === void 0 ? void 0 : _c.trim()) ||
        (isEqual((_d = warehouseUser === null || warehouseUser === void 0 ? void 0 : warehouseUser.first_name) === null || _d === void 0 ? void 0 : _d.trim(), (_e = initWarehouseUser === null || initWarehouseUser === void 0 ? void 0 : initWarehouseUser.first_name) === null || _e === void 0 ? void 0 : _e.trim()) &&
            isEqual((_f = warehouseUser === null || warehouseUser === void 0 ? void 0 : warehouseUser.last_name) === null || _f === void 0 ? void 0 : _f.trim(), (_g = initWarehouseUser === null || initWarehouseUser === void 0 ? void 0 : initWarehouseUser.last_name) === null || _g === void 0 ? void 0 : _g.trim()) &&
            isEqual((_h = warehouseUser === null || warehouseUser === void 0 ? void 0 : warehouseUser.phone) === null || _h === void 0 ? void 0 : _h.trim(), (_j = initWarehouseUser === null || initWarehouseUser === void 0 ? void 0 : initWarehouseUser.phone) === null || _j === void 0 ? void 0 : _j.trim()) &&
            isEqual((_k = warehouseUser === null || warehouseUser === void 0 ? void 0 : warehouseUser.email) === null || _k === void 0 ? void 0 : _k.trim(), (_l = initWarehouseUser === null || initWarehouseUser === void 0 ? void 0 : initWarehouseUser.email) === null || _l === void 0 ? void 0 : _l.trim())) ||
        !validator.validate(warehouseUser.email);
    const handleInputChange = (field, value) => {
        setWarehouseUser((prev) => (Object.assign(Object.assign({}, prev), { [field]: value })));
    };
    const handleChangePassword = (newPassword) => {
        CustomersActionCreators.updatePassword(warehouseUser._id, newPassword);
    };
    const handleSave = async () => {
        const existingFields = ['first_name', 'last_name', 'phone', 'email'];
        const updates = {};
        existingFields.forEach((k) => {
            if (warehouseUser[k].trim() !== initWarehouseUser[k].trim()) {
                updates[k] = warehouseUser[k].trim();
            }
        });
        if (Object.keys(updates).length) {
            updates._id = warehouseUser._id;
            // Make Api Call
            const result = await CustomersAPIUtils.updateWarehouseUser(updates);
            if ((result === null || result === void 0 ? void 0 : result.success) && (result === null || result === void 0 ? void 0 : result.user)) {
                setWarehouseUser(result.user);
            }
        }
    };
    const renderPhoto = () => {
        const userId = warehouseUser === null || warehouseUser === void 0 ? void 0 : warehouseUser._id;
        return (React.createElement("div", { "data-testid": `${pageTestKey}-avatar`, className: "dropdown-wrapper" },
            React.createElement(AvatarWithUpload, { key: userId, userId: userId, style: {
                    borderWidth: 2,
                    borderColor: '#5cb85c',
                    borderStyle: 'dashed',
                    borderRadius: 5,
                    display: 'inline-block',
                    padding: 0,
                    textAlign: 'center',
                } })));
    };
    const { first_name = '', last_name = '', phone = '', email = '', } = warehouseUser;
    return (React.createElement(Container, { className: "lg:mt-0 mt-4" },
        React.createElement("div", { "data-tesid": `${pageTestKey}-page`, className: "lg:grid lg:grid-cols-12 lg:gap-6 mt-10" },
            React.createElement("div", { className: "lg:col-span-3" },
                React.createElement(Sidebar, { activePage: "profile" })),
            React.createElement("div", { "data-testid": `${pageTestKey}-container`, className: "lg:col-span-6" },
                React.createElement(CargomaticCard, { header: () => (React.createElement("div", { className: "flex items-center justify-between" },
                        React.createElement("h3", { className: "my-0" },
                            t('WELCOME'),
                            ", \u00A0 ",
                            displayName))), footer: () => (React.createElement("div", { "data-testid": `${pageTestKey}-footer`, className: "form-actions" },
                        React.createElement("button", { "data-testid": `${pageTestKey}-save-button`, disabled: saveDisabled, className: "button button-green", onClick: handleSave }, titleize(t('SAVE'))))), showFooter: true, grayFooter: true },
                    React.createElement("div", { className: "grid grid-cols-6 gap-4" },
                        React.createElement("div", { className: "col-span-6 sm:col-span-3" },
                            React.createElement(CargomaticInput, { id: `${pageTestKey}-first-name`, label: titleize(t('FIRST_NAME')), type: "text", className: "", placeholder: t('ENTER_FIRST_NAME'), value: first_name, onChange: (val) => handleInputChange('first_name', val) })),
                        React.createElement("div", { className: "col-span-6 sm:col-span-3" },
                            React.createElement(CargomaticInput, { id: `${pageTestKey}-last-name`, label: titleize(t('LAST_NAME')), className: "", type: "text", placeholder: t('ENTER_LAST_NAME'), value: last_name, onChange: (val) => handleInputChange('last_name', val) }))),
                    React.createElement("div", { className: "grid grid-cols-6 gap-4 mt-3" },
                        React.createElement("div", { "data-testid": `${pageTestKey}-phone`, className: "col-span-6 sm:col-span-3" },
                            React.createElement("label", { className: "mb-1 form-label" }, titleize(t('PHONE'))),
                            React.createElement(PhoneField, { id: "carrier-phone", containerClassName: "mt-3", onChange: (val) => handleInputChange('phone', val), value: phone })),
                        React.createElement("div", { className: "col-span-6 sm:col-span-4" },
                            React.createElement(CargomaticInput, { id: `${pageTestKey}-email`, label: titleize(t('EMAIL')), type: "email", className: "", value: email, placeholder: t('ENTER_EMAIL'), onChange: (val) => handleInputChange('email', val) }))))),
            React.createElement("div", { className: "lg:col-span-3 col-auto space-y-4" },
                renderPhoto(),
                React.createElement("div", { style: { marginTop: '1em' } },
                    React.createElement("button", { "data-testid": `${pageTestKey}-change-password-button`, className: "button button-red", onClick: () => setShowChangePasswordModal(true) }, t('CHANGE_PASSWORD')))),
            React.createElement(ChangePasswordModal, { show: showChangePasswordModal, onHide: () => setShowChangePasswordModal(false), onSave: handleChangePassword }))));
};
export default Profile;
